import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=38a3b3f4&scoped=true&"
import script from "./GoogleSignIn.vue?vue&type=script&lang=ts&"
export * from "./GoogleSignIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3b3f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a3b3f4')) {
      api.createRecord('38a3b3f4', component.options)
    } else {
      api.reload('38a3b3f4', component.options)
    }
    module.hot.accept("./GoogleSignIn.vue?vue&type=template&id=38a3b3f4&scoped=true&", function () {
      api.rerender('38a3b3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/auth/GoogleSignIn.vue"
export default component.exports